/* eslint-disable @typescript-eslint/no-explicit-any */

import { toNumber } from 'es-toolkit/compat';

const numberFilter = {
  formatModelValue(modelValue: string) {
    let viewValue: any = null;

    if ((typeof modelValue === 'number') || (typeof modelValue === 'string')) {
      viewValue = modelValue;
    }

    if ((viewValue == null) || Number.isNaN(viewValue)) {
      return '';
    }

    return viewValue;
  },

  parseViewValue(viewValue: string) {
    let modelValue: any = null;

    if (viewValue != null) {
      const parsed = toNumber(viewValue);
      if (!Number.isNaN(parsed)) {
        modelValue = parsed;
      }
    }

    if ((modelValue == null) || viewValue === '') {
      return '';
    }
    return modelValue;
  },

  formatOnChange: false,
};

export default numberFilter;
